import { DTOBrand, DTODesignSystem, DTODesignSystemVersion, } from "../design-systems";
import { DTOUserWorkspaceMembership } from "../workspaces";
import { z } from "zod";
export const DTOAppBootstrapDataQuery = z.object({
    preferredWorkspaceId: z.string().optional(),
    preferredDesignSystemId: z.string().optional(),
    preferredVersionId: z.string().optional(),
    preferredBrandId: z.string().optional(),
});
export const DTOAppBootstrapDataResponse = z.object({
    workspaceMembership: DTOUserWorkspaceMembership.optional(),
    designSystem: DTODesignSystem.optional(),
    version: DTODesignSystemVersion.optional(),
    brand: DTOBrand.optional(),
});
